export enum ReferenceSystem {
  LOCAL_FLOATING = 'LOCAL_FLOATING',
  GLOBAL = 'GLOBAL',
}
